import observeRequest from 'helpers/fcObserveRequest'
import { map, switchMap } from 'rxjs/operators'
import { URL_USER_FAVOURITES } from 'constants/urls'
import { FAVOURITES } from 'constants/requests'
import { fetch, refresh } from './ApiService'
import { $isLogged } from './SessionService'
import { of } from 'rxjs'

const extractFavourites = (response, resourceType) => {
  let arr
  if (Array.isArray(response?.favourites)) {
    arr = response.favourites
  } else if (typeof response === 'string') {
    try {
      const parsed = JSON.parse(response)
      arr = Array.isArray(parsed?.favourites) ? parsed.favourites : []
    } catch (e) {
      console.error('Failed to parse favourites response:', e)
      arr = []
    }
  } else {
    arr = []
  }
  const found = arr.find(f => f.resourceType === resourceType)
  return found ? found.resourceIds : []
}

export const requestUserFavourites = resourceType => $isLogged.pipe(
  switchMap(({ isLogged }) => { // if we stick with rxjs might be worth extracting this functionality into a helper
    if (!isLogged) {
      return of({})
    }
    return fetch(FAVOURITES)
  }),
  map(response => extractFavourites(response, resourceType))
)

export const refereshUserFavourites = () => refresh(FAVOURITES)

export const addUserFavourite = (resourceId, resourceType) =>
  observeRequest({
    url: URL_USER_FAVOURITES,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ resourceId, resourceType })
  })

export const removeUserFavourite = (resourceId, resourceType) =>
  observeRequest({
    url: URL_USER_FAVOURITES,
    method: 'delete',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ resourceId, resourceType })
  })
